import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { REDESIGN_COLORS } from '../../styles/colors';
import CollapsibleSection from './CollapsibleSection';

/**
 * Specification row config: icon, label, and value accessor function.
 */
const SPEC_ROWS = [
  {
    key: 'fuel_type',
    icon: 'gas-station',
    label: 'Fuel Type',
    getValue: (snapshot) => snapshot?.fuel_type,
  },
  {
    key: 'body_type',
    icon: 'car-side',
    label: 'Body Type',
    getValue: (snapshot) => snapshot?.body_type,
  },
  {
    key: 'transmission',
    icon: 'car-shift-pattern',
    label: 'Transmission',
    getValue: (snapshot) => snapshot?.transmission,
  },
  {
    key: 'drivetrain',
    icon: 'car-cruise-control',
    label: 'Drivetrain',
    getValue: (_snapshot, _extraData, buildData) => buildData?.drivetrain,
  },
  {
    key: 'doors',
    icon: 'car-door',
    label: 'Doors',
    getValue: (_snapshot, _extraData, buildData) => buildData?.doors,
  },
  {
    key: 'engine',
    icon: 'engine',
    label: 'Engine',
    getValue: (_snapshot, _extraData, buildData) => buildData?.engine,
  },
  {
    key: 'performance_power_bhp',
    icon: 'speedometer',
    label: 'Power',
    getValue: (_snapshot, _extraData, buildData) => buildData?.performance_power_bhp ? `${buildData.performance_power_bhp} bhp` : null,
  },
  {
    key: 'euro_status',
    icon: 'leaf',
    label: 'Euro Standard',
    getValue: (_snapshot, _extraData, buildData) => buildData?.euro_status ? `Euro ${buildData.euro_status}` : null,
  },
  {
    key: 'co2_emissions',
    icon: 'cloud-outline',
    label: 'CO₂ Emissions',
    getValue: (snapshot) => snapshot?.co2_emissions,
  },
  {
    key: 'insurance_group',
    icon: 'shield-check-outline',
    label: 'Insurance Group',
    getValue: (snapshot) => snapshot?.insurance_group,
  },
  {
    key: 'ev_vehicle_range',
    icon: 'ev-station',
    label: 'EV Range',
    getValue: (_snapshot, _extraData, buildData) => buildData?.ev_vehicle_range ? `${buildData.ev_vehicle_range} mi` : null,
  },
];

/**
 * SpecificationsSection - Key-value specification rows in a CollapsibleSection.
 *
 * @param {Object} props
 * @param {Object} props.listingSnapshot - listing_snapshot from feed entry
 * @param {Object} [props.extraData] - Tier 2 data from marketcheck_listing_cache
 */
const SpecificationsSection = ({ listingSnapshot, extraData, buildData, onToggle }) => {
  const visibleRows = SPEC_ROWS.filter(
    (row) => row.getValue(listingSnapshot, extraData, buildData) != null
  );

  if (visibleRows.length === 0) return null;

  return (
    <CollapsibleSection title="Specifications" onToggle={onToggle}>
      <View style={styles.rows}>
        {visibleRows.map((row) => (
          <View key={row.key} style={styles.row}>
            <View style={styles.left}>
              <MaterialCommunityIcons
                name={row.icon}
                size={18}
                color={REDESIGN_COLORS.textSecondary}
              />
              <Text style={styles.label}>{row.label}</Text>
            </View>
            <Text style={styles.value}>
              {String(row.getValue(listingSnapshot, extraData, buildData))}
            </Text>
          </View>
        ))}
      </View>
    </CollapsibleSection>
  );
};

const styles = StyleSheet.create({
  rows: {
    gap: 12,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  left: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  label: {
    fontFamily: 'Satoshi-Medium',
    fontSize: 14,
    color: REDESIGN_COLORS.textSecondary,
  },
  value: {
    fontFamily: 'Satoshi-Medium',
    fontSize: 14,
    color: REDESIGN_COLORS.textPrimary,
  },
});

export default SpecificationsSection;
